var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6623 14.1404C17.5303 13.3608 15.9673 13.6842 15.1969 14.8429L14.3826 16.1362C14.2055 16.4056 13.7948 16.5157 13.4986 16.3477C10.5897 14.6497 8.15974 12.3405 6.32548 9.49959C6.13573 9.2057 6.21369 8.82062 6.49845 8.6041L7.74458 7.70154C8.87511 6.89811 9.08837 5.3316 8.25817 4.2102L5.94823 1.1131C5.24454 0.18762 3.8666 0.089383 3.07614 0.926337C0.020834 4.14824 -0.848986 9.22492 6.63006 16.3572C14.1 23.4627 19.1278 22.3474 22.1655 19.1614C22.9827 18.3153 22.8126 16.9392 21.8424 16.2838L18.6623 14.1404Z",
    fill: "#15243E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2a6e0a6a8ad1fa865c01feccfeaee5d8.svg";
export { ForwardRef as ReactComponent };